<template>
  <div class="dashboard">
    <div class="columns">
      <div class="column is-6 is-centered is-center">
        <div class="box quote">
          <h1 class="title is-1 is-large has-text-centered">"{{quote.text}}"</h1>
          <h2 class="is-2 title is-large pull-right">-{{quote.author}}</h2>
          <br style="clear:both">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dash board',
  data () {
    return {
      quotes: [
        {
          author: 'Sylvia Plath',
          text: 'Jag älskar mina refuseringsbrev. De bevisar att jag faktiskt försöker.'
        },
        {
          author: 'Susan Sontag',
          text: 'Man blir aldrig tillräckligt ensam för att skriva.'
        },
        {
          author: 'Randy Newman',
          text: 'Sänk dina krav. Att skapa skit är bättre än att inte skapa något alls.'
        },
        {
          author: 'Thomas Mann',
          text: 'En författare är en person för vilken skrivandet är svårare än för andra människor.'
        },
        {
          author: 'Othello Bach',
          text: 'Dialogen har endast två syften: Att fördjupa karaktären, och att driva handlingen framåt.'
        },
        {
          author: 'Sinclair Lewis',
          text: 'Författare har en sällsynt gåva som inte andra har fått: Vi kan göra människor uttråkade långt efter vår egen död.'
        },
        {
          author: 'Franz Kafka',
          text: 'Envar som kan se skönheten, blir aldrig gammal.'
        },
        {
          author: 'Kerstin Ekman',
          text: 'Jag känner inte till någon stor författare som inte varit en riktigt stor läsare. Kärlek kommer ur kärlek, och litteratur kommer ur litteratur.'
        },
        {
          author: 'Voltaire',
          text: 'Adjektivet är substantivets fiende.'
        },
        {
          author: 'Birgitta Stenberg',
          text: 'Jag fick henne att lova att inte läsa dem. Och i och med att hon hade lovat kunde hon inte diskutera dem med mig, även om hon hade läst dem. Bra tips för alla som är oroliga för vad mamma ska säga.'
        }

      ]
    }
  },
  computed: {
    quote: function () {
      const index = Math.floor(Math.random() * this.quotes.length)
      return this.quotes[index]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
